import { PortableText } from '@portabletext/react';
import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';
import { Container } from 'react-bootstrap';
import imgFallback from 'src/utils/image';
import * as styles from './Timeline.module.scss';
import { TimelineItems } from './TimelineItems';

export const Timeline = ({ image, imageDescription, timelineItems }) => {
  if (timelineItems.length === 0) {
    return null;
  }

  const maxNumOfTimelineItems = 3;

  const timeLineItemsShown = timelineItems.slice(0, maxNumOfTimelineItems);

  const getFormattedPeriod = () => {
    const startingYear = timeLineItemsShown[0].year;
    const endingYear = timeLineItemsShown[timeLineItemsShown.length - 1].year;

    if (startingYear === endingYear) {
      return startingYear;
    }

    return `${startingYear}-${endingYear}`;
  };

  return (
    <section className={`${styles.section} py-6`}>
      <Container>
        <h1 className={`${styles.title} mb-6 text-center`}>{getFormattedPeriod()}</h1>

        <div className={styles.container}>
          <div className={`${styles.summary} mt-md-5`}>
            <GatsbyImage className="mb-3" alt={image?.alt ?? ''} image={image?.image?.asset?.gatsbyImageData ?? imgFallback} />

            <div className={styles.imageDescription}>
              <PortableText value={imageDescription} />
            </div>
          </div>
          <div className={styles.timeline}>
            <TimelineItems items={timeLineItemsShown} />
          </div>
        </div>
      </Container>
    </section>
  );
};

Timeline.propTypes = {
  image: PropTypes.shape({}).isRequired,
  imageDescription: PropTypes.arrayOf(PropTypes.shape({})),
  timelineItems: PropTypes.arrayOf(
    PropTypes.shape({
      _key: PropTypes.string.isRequired,
      year: PropTypes.number.isRequired,
      description: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
      location: PropTypes.string,
    })
  ).isRequired,
};

Timeline.defaultProps = {
  imageDescription: null,
};
